import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  type: 'object',
  properties: {
    deactivate: {
      title: 'Blokada bezterminowa (deaktywacja karty)',
      type: 'boolean',
      default: false,
      enum: [true, false]
    },
    blockEndDate: {
      type: 'string',
      title: 'Zablokuj do *',
      format: 'date',
      fieldRequired: '!this.deactivate'
    }
  }
};
